export const state = () => ({
  forecastDemandList: [],
  eventOccurrenceList: [],
});
